'use strict';

(function () {
  'use strict';

  angular.module('msOnboarding').controller('SurveyCtrl', SurveyCtrl);
  SurveyCtrl.$inject = ['$rootScope', '$state', '$scope', 'surveySvc', '$timeout', '$translate', 'NotifyingSvc', 'loadingScreenSvc'];

  function SurveyCtrl($rootScope, $state, $scope, surveySvc, $timeout, $translate, NotifyingSvc, loadingScreenSvc) {
    $rootScope.$state = $state;
    var vm = this;
    vm.success = false;
    vm.answers = [];
    vm.program = null;
    vm.$onInit = init;

    function init() {
      vm.questions = [{
        name: 'lifesGood',
        label: vm.context + '.survey.questions.lifesGood.question'
      }, {
        name: 'struggle',
        label: vm.context + '.survey.questions.struggle.question'
      }, {
        name: 'challenge',
        label: vm.context + '.survey.questions.challenge.question'
      }, {
        name: 'curious',
        label: vm.context + '.survey.questions.curious.question'
      }];
      vm.title = 'onboarding.survey.bringsyou';
      vm.content = '';
      //set page title only after translation is available
      $translate.onReady(function () {
        setPageTitle(1);
      });

      $timeout(function () {
        loadingScreenSvc.removeLoadingScreen();
      }, 1000);
    }

    // For WCAG - focus survey-main on vm.program change
    $scope.$watch('vm.program', function () {
      if (vm.program === null) {
        $timeout(function () {
          var title = angular.element('#title.page-title');
          if (title && title[0]) {
            title[0].focus();
          }
        }, 100);
      } else {
        $timeout(function () {
          var surveyMain = angular.element('#survey-main');
          if (surveyMain && surveyMain[0]) {
            surveyMain[0].focus();
          }
        }, 100);
      }
    });

    vm.next = function (question) {
      vm.program = question.name;
      for (var key in vm.answers) {
        vm.answers[key] = key === vm.program;
      }
      vm.title = vm.context + '.survey.questions.' + question.name + '.title';
      vm.content = vm.context + '.survey.questions.' + question.name + '.content';
      surveySvc.setQ1(question.name);
      setPageTitle(2);
    };

    vm.back = function () {
      init();
      vm.program = null;
    };

    vm.getTemplateUrl = function () {
      return 'onboarding/templates/survey/survey-onboarding.html';
    };

    function setPageTitle(step) {
      $translate(["pageTitles.survey"], { index: step, length: 2 }).then(function (res) {
        NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.PAGE_TITLE, {
          pageTitle: res["pageTitles.survey"]
        });
      });
    }
  }
})();